// extracted by mini-css-extract-plugin
export var defaultWrapper = "_m4-3";
export var downloadButton = "_m4-4";
export var fileContainer = "_m4-9 _m4-7";
export var fileContainerBase = "_m4-7";
export var fileContainerFixedHeight = "_m4-8 _m4-7";
export var fileInfo = "_m4-5";
export var fileInfoWidthRestricted = "_m4-6";
export var fileType = "_m4-1";
export var fileTypeName = "_m4-2";
export var image = "_m4-0";
export var link = "_m4-b";
export var overflowEllipsis = "_m4-a";